import { useEffect } from 'react';

export const setRebranding = () => {
    document.body.classList.add('rebranding');
};

export const useGlobalRebranding = (isRebranding: boolean) => {
    useEffect(() => {
        if (!isRebranding) {
            return;
        }
        return setRebranding();
    }, [isRebranding]);
};

export const setRebrandingQuota = () => {
    document.body.classList.add('rebranding_quota');
};

export const clearRebrandingQuota = () => {
    document.body.classList.remove('rebranding_quota');
};
